<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('保健室预约', '预约人姓名、电话、场所名称、使用部门、保健主题、人数、预约日期、预约时间、预约状态',defaultParams)">导出Excel</el-button>
            </template>
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.status===0"
                           @click.stop="handleReply(scope.row,scope.index)">审核
                </el-button>
            </template>
            <template slot-scope="scope" slot="status"> <!--状态：0待审核，1审核通过，2审核不通过	-->
                <span v-if="scope.row.status===0">待审核</span>
                <span v-if="scope.row.status===1" style="color: green">审核通过</span>
                <span v-if="scope.row.status===2" style="color: crimson">审核未通过</span>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    name: 'RoomOrderHealth',
    props: ['defaultParams'],
    mixins: [curd],
    data: function () {
      return {
        url: '/room/order',
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增会议室', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '审核', // 新增按钮文案
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '预约人姓名',
              prop: 'user-username',
              display: false,
              span: 24
            },
            {
              label: '电话',
              prop: 'user-tel',
              display: false,
              span: 24
            },
            {
              label: '使用部门',
              prop: 'class',
              display: false,
              span: 24
            },
            {
              label: '保健主题',
              prop: 'content',
              display: false,
              span: 24
            },
            {
              label: '参与人数',
              prop: 'num',
              display: false,
              span: 24
            },
            {
              label: '预约日期',
              prop: 'date',
              display: false,
              span: 24
            },
            {
              label: '预约时间',
              display: false,
              prop: 'room_order_times-time',
              type: 'select',
              span: 24
            },
            {
              label: '预约状态',
              prop: 'status',
              search: true,
              slot: true,
              type: 'select',
              dicUrl: this.getDic('affair.car_status'),
              rules: [{
                required: true, message: '状态不能为空', trigger: 'blur'
              }]
            },
            {
              label: '审核备注',
              prop: 'note',
              span: 24,
              hide: true,
            }
          ]
        },
      }
    },
    methods: {
      // 审核
      handleReply(row, index) {
        this.$refs.crud.rowEdit(row, index)
      },
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field, item) {
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          // 类型：1会议室，2VIP食堂, 3培训场地, 4.PDR室
          this.api.get(this.url + '/export?type=4&filename=' + filename + '&id='+item.room_id, this.searchParams).then((re) => {
            message.close()
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: '请点击该链接:<a target="_blank" href="' + url + '">下载Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      },
    }
  }
</script>
